import { ChatMessageEntityLinkType } from '@texas/api/endpoints/chat/chatApi';
import { DimensionGroupHoverCard } from './DimensionGroupHoverCard';

export const hoverCards: Record<
  ChatMessageEntityLinkType,
  ((id: number) => React.ReactNode) | null
> = {
  [ChatMessageEntityLinkType.Customer]: null,
  [ChatMessageEntityLinkType.Concept]: null,
  [ChatMessageEntityLinkType.ProductGroup]: null,
  [ChatMessageEntityLinkType.Material]: null,
  [ChatMessageEntityLinkType.Quality]: null,
  [ChatMessageEntityLinkType.DimensionGroup]: (id: number) => (
    <DimensionGroupHoverCard dimensionGroupId={id} />
  ),
  [ChatMessageEntityLinkType.Branch]: null,
};
